<template>
    <div class="page questions-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <edit-question v-if="loadedData" :question="loadedData.question" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import EditQuestion from './EditQuestion'

export default {
    name: "",
    components: {
        EditQuestion
    },
    data(){
        return {
            loading: false,
            loadedData: null,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        }
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                window.axios.get(`/exams/questions/${this.id}/edit`).then(response=>{
                    this.loadedData = response.data;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        // this.$router.push('/not-found');
                        this.showMsg('لم يتم العثور على نتيجة');
                    }else if (e && e.response && e.response.status === 403){
                        this.showMsg('ليس لديك صلاحية القيام بهذا الإجراء', 'warning');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                    this.$router.go(-1);
                });
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    created(){
        
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>

</style>
